import {
    Autocomplete,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import { useAuth } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { ROLE_MAP } from "utils/constants";
import { useNavigate } from "react-router-dom";

const EstablishmentSelectionModal = ({
    setOpen,
    checkPendingNotification,
    pendingNotificationIntervalId,
    setPendingNotificationIntervalId,
    setRoleSelectedCallback,
}) => {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();

    const [establishmentSelected, setEstablishmentSelected] = useState(null);
    const [roleSelected, setRoleSelected] = useState(null);
    const [establishments, setEstablishments] = useState([]);
    const [roles, setRoles] = useState([]);
    const rolesEstablishment = JSON.parse(localStorage.getItem("rolesEstablishment"));

    useEffect(() => {
        if (rolesEstablishment) {
            if (rolesEstablishment.length === 1 && rolesEstablishment[0].roles.length === 1) {
                const onlyEstablishment = {
                    id: rolesEstablishment[0].establishment.id,
                    name: rolesEstablishment[0].establishment.name,
                    roles: rolesEstablishment[0].roles.map((role) => ({ name: role })),
                };
                const onlyRole = onlyEstablishment.roles[0];

                setEstablishmentSelected(onlyEstablishment);
                setRoles(onlyEstablishment.roles);

                localStorage.setItem("selectedEstablishment", JSON.stringify(onlyEstablishment));
                localStorage.setItem("selectedRole", JSON.stringify(onlyRole));

                const updatedAuth = {
                    ...auth,
                    selectedEstablishment: onlyEstablishment,
                    selectedRole: onlyRole,
                };
                setAuth(updatedAuth);
                setRoleSelected(onlyRole);
                setRoleSelectedCallback(onlyRole);
                onClickRole(onlyRole);
                setOpen(false);
            } else {
                setEstablishments(
                    rolesEstablishment.map((item) => {
                        return {
                            id: item.establishment.id,
                            name: item.establishment.name,
                            roles: item.roles.map((role) => {
                                return { name: role };
                            }),
                        };
                    })
                );
            }
        }
    }, [rolesEstablishment]);

    useEffect(() => {
        establishmentSelected && setRoles(establishmentSelected.roles);
    }, [establishmentSelected]);

    const onClickRole = (selectedRole) => {
        const dataUpdateAuth = { ...auth, selectedRole: selectedRole };
        clearInterval(pendingNotificationIntervalId);
        checkPendingNotification(selectedRole.name, dataUpdateAuth);
        const pendingNotificationInterval = setInterval(() => {
            checkPendingNotification(selectedRole.name, dataUpdateAuth);
        }, 60000); // 1 minute
        setPendingNotificationIntervalId(pendingNotificationInterval);
    };

    return (
        <>
            <DialogTitle sx={{ width: { md: "500px" } }}>
                Seleccione Establecimiento y Rol
            </DialogTitle>
            <DialogContent>
                <Autocomplete
                    sx={{ marginTop: "16px" }}
                    id="autocomplete"
                    freeSolo
                    options={establishments}
                    renderOption={(props, option) => {
                        return (
                            <li {...props} key={option.id}>
                                {option.name}
                            </li>
                        );
                    }}
                    getOptionLabel={(option) => {
                        return option.name;
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label="Seleccione una establecimiento" />
                    )}
                    onChange={(evt, newValue) => {
                        if (newValue !== null) {
                            setEstablishmentSelected(newValue);
                            localStorage.setItem("selectedEstablishment", JSON.stringify(newValue));
                            localStorage.setItem("selectedRole", null);
                            setAuth({
                                ...auth,
                                selectedEstablishment: newValue,
                                selectedRole: null,
                            });
                        }
                    }}
                />

                <Autocomplete
                    sx={{ marginTop: "16px" }}
                    id="autocomplete"
                    freeSolo
                    options={roles}
                    renderOption={(props, option) => {
                        return (
                            <li {...props} key={option.name}>
                                {ROLE_MAP[option.name]}
                            </li>
                        );
                    }}
                    getOptionLabel={(option) => {
                        return ROLE_MAP[option.name];
                    }}
                    renderInput={(params) => <TextField {...params} label="Seleccione un rol" />}
                    onChange={(evt, newValue) => {
                        if (newValue !== null) {
                            localStorage.setItem("selectedRole", JSON.stringify(newValue));
                            setRoleSelected(newValue);
                            setAuth({ ...auth, selectedRole: newValue });
                            onClickRole(newValue);
                        }
                    }}
                />
                <Box mt={1}>
                    <small
                        style={{
                            display: "block",
                            fontSize: "12px",
                            textAlign: "center",
                        }}
                    >
                        <i>
                            Si aún no tienes un rol y una establecimiento deberás esperar que un
                            administrador acepte tu solicitud!
                        </i>{" "}
                        <a href="/profile">Ir al perfil</a>
                    </small>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    type="submit"
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        if (roleSelected) {
                            setRoleSelectedCallback(roleSelected);
                        }
                    }}
                >
                    Continuar
                </Button>
            </DialogActions>
        </>
    );
};

export default EstablishmentSelectionModal;
